import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import slugify from "slugify";

type FieldSyncProps = {
  source: string;
  destination: string;
  transformFn?: (sourceValue: string) => string;
};

const noTransform = (s: string) => s;

export const displayNameToSlug = (value: string) =>
  slugify(value, { lower: true, trim: true });

export const FieldSync: React.FC<FieldSyncProps> = ({
  source,
  destination,
  transformFn = noTransform,
}) => {
  const { getFieldState, setValue } = useFormContext();
  const sourceValue = useWatch({ name: source }) as string;

  useEffect(() => {
    if (sourceValue) {
      const sourceState = getFieldState(source);
      const isSourceTouched = sourceState.isTouched || sourceState.isDirty;

      const destinationState = getFieldState(destination);
      const isDestinationTouched =
        destinationState.isTouched || destinationState.isDirty;

      if (isSourceTouched && !isDestinationTouched) {
        setValue(destination, transformFn(sourceValue), {
          shouldValidate: true,
        });
      }
    }
  }, [destination, getFieldState, setValue, source, sourceValue, transformFn]);

  return null;
};
